export const reverseGeocode = async (
  latitude: number,
  longitude: number
): Promise<string> => {
  try {
    if (!latitude || !longitude) return "Location data not available";

    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`
    );

    const data = await response.json();

    if (data.error) {
      return "Location unknown";
    }

    const address = data.address || {};
    const locationParts = [
      address.road,
      address.suburb,
      address.neighbourhood,
      address.city_district,
      address.city,
      address.state,
    ].filter(Boolean);

    return locationParts.join(", ") || "Location unknown";
  } catch (error) {
    console.error("Reverse geocoding failed:", error);
    return "Location unknown";
  }
};
